import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin } from "lucide-react";

/**
 * Shared blog card used on /blog, home preview and related posts.
 * Shows category label, optional district, reading time, title and excerpt.
 */
export const BlogCard = ({ post, surface = "bg-[#141517]", compact = false }) => {
  if (!post) return null;
  const label = post.district_name
    ? post.district_name
    : post.category_name || "Rehber";
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid="blog-card"
      className={`group block h-full rounded-2xl overflow-hidden border border-white/10 ${surface} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C8A24A]`}
    >
      <div className="aspect-[16/10] overflow-hidden relative">
        <img
          src={post.hero_image}
          alt={post.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {post.district_name && post.category_name && (
          <span
            data-testid="blog-card-category"
            className="absolute top-3 left-3 rounded-full bg-[#0E0F10]/80 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-[0.12em] text-[#D7B86A] border border-white/10"
          >
            {post.category_name}
          </span>
        )}
      </div>
      <div className={compact ? "p-4" : "p-5"}>
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-[#C8A24A]">
          {post.district_name ? (
            <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {label}</span>
          ) : (
            <span>{label}</span>
          )}
          {post.reading_minutes ? (
            <span className="inline-flex items-center gap-1 text-[#7C766B] normal-case tracking-normal">
              <span aria-hidden>·</span>
              <Clock className="w-3 h-3" /> {post.reading_minutes} dk
            </span>
          ) : null}
        </div>
        <h3 className={`font-display text-[#F7F2E8] mt-2 leading-snug line-clamp-2 ${compact ? "text-lg" : "text-xl"}`}>
          {post.title}
        </h3>
        {!compact && <p className="text-sm text-[#9A9387] mt-2 line-clamp-2">{post.excerpt}</p>}
        <span className="inline-flex items-center gap-1 text-sm text-[#D7B86A] mt-4 group-hover:gap-2 transition-[gap] duration-200">
          Devamını oku <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};

export default BlogCard;
